import {
    SelectList,
    SelectListItem,
    SelectSeperator,
    SelectSubList,
    SelectSubTitle,
    SelectTitle,
    SelectZeroResultIcon,
    SelectZeroResults,
} from "./Styled";
import React from "react";
import {SelectListHandler} from "./SelectListHandler";
import {MULTI_SELECT, SINGLE_SELECT} from "../utils";
import CheckBox from "../../CheckBox";
import {SelectMenuInterface, BasicItem} from "../types";

const SelectMenuWithOptGroup = function <T extends BasicItem>({
    isOpen,
    getItemProps,
    highlightedIndex,
    itemToString,
    type,
    maxSelectedLength,
    // selectedItems,
    userSelectedItems,
    optGroupItem,
    withOptGroup,
    // menuLegend,
    fieldName,
    withSearch,
}: SelectMenuInterface<T>): JSX.Element {
    type defaultObjectType = {
        sections: JSX.Element[];
        itemIndex: number;
    };
    const defaultObject: defaultObjectType = {
        sections: [],
        itemIndex: 0,
    };
    const multiSelectIds: number[] = [];
    if (type === MULTI_SELECT) {
        userSelectedItems.reduce((finalList, item) => {
            item && finalList.push(item.id);
            return finalList;
        }, multiSelectIds);
    }

    return (
        <SelectList type={type}>
            {
                optGroupItem?.length === 0 ? (
                    <SelectZeroResults>
                        <SelectZeroResultIcon />
                        <p>No Results Found</p>
                    </SelectZeroResults>
                ) : !withSearch && type === SINGLE_SELECT ? (
                    <SelectTitle withSearch={withSearch}>SELECT ONE</SelectTitle>
                ) : (
                    ""
                )
                //     < SelectTitle >
                // {
                //     menuLegend
                //     ? menuLegend
                //         : type === MULTI_SELECT
                //             ? "Choose Options"
                //             : "SELECT ONE"
                // }
                // </SelectTitle>
            }
            {
                optGroupItem?.reduce((finalMenu, section, sectionIndex) => {
                    finalMenu.sections.push(
                        <React.Fragment key={`optGroup${sectionIndex}`}>
                            <SelectListItem type={type}>
                                <SelectSubTitle>{section.groupName}</SelectSubTitle>
                                <SelectSubList isOpen={isOpen}>
                                    {section.groupOptions.map((item) => {
                                        const index = finalMenu.itemIndex++;
                                        let isSelected = false,
                                            isMaxLimitReached = false;
                                        if (type === MULTI_SELECT) {
                                            isSelected = multiSelectIds.includes(item.id);
                                            isMaxLimitReached =
                                                multiSelectIds.length === maxSelectedLength;
                                        }
                                        return (
                                            <React.Fragment key={`menu${index}`}>
                                                <SelectListHandler
                                                    item={item}
                                                    getItemProps={getItemProps}
                                                    withOptGroup={withOptGroup}
                                                    highlightedIndex={highlightedIndex}
                                                    isSelected={isSelected}
                                                    index={index}
                                                    isDisabled={
                                                        (isMaxLimitReached && !isSelected) ||
                                                        typeof item.disabled !== "undefined"
                                                    }
                                                >
                                                    {type === MULTI_SELECT && (
                                                        <CheckBox
                                                            id={`${fieldName}_${item.id}`}
                                                            isChecked={isSelected}
                                                            onChange={() => null}
                                                            isDisabled={
                                                                isMaxLimitReached && !isSelected
                                                            }
                                                            inputRFF={{
                                                                onBlur: () => null,
                                                                onFocus: () => null,
                                                                onChange: () => null,
                                                                name: fieldName,
                                                                value: isSelected,
                                                                checked: isSelected,
                                                            }}
                                                        />
                                                    )}

                                                    {itemToString ? itemToString(item) : ""}
                                                </SelectListHandler>
                                                <SelectSeperator />
                                            </React.Fragment>
                                        );
                                    })}
                                </SelectSubList>
                            </SelectListItem>
                            <SelectSeperator />
                        </React.Fragment>,
                    );
                    return finalMenu;
                }, defaultObject).sections
            }
        </SelectList>
    );
};
export default SelectMenuWithOptGroup;
